import {useFormContext} from "react-hook-form";

import Button from "@/components/button/Button.tsx";
import {CDNImage} from "@/components/cdnImage/CDNImage.tsx";
import {Checkbox} from "@/components/checkbox/Checkbox.tsx";
import {ServiceField} from "@/lib/constants/service.ts";

interface Props {
  name: string;
  id: number;
  logo_src: string;
  group: string;
  title: string;
  display_title?: string;
  onClick: () => void;
  disabled: boolean;
  className?: string;
}

export const ThirdPartyComponent = ({
  name,
  id,
  logo_src,
  group,
  title,
  display_title,
  onClick,
  disabled,
  className,
}: Props) => {
  const {watch} = useFormContext();
  const selectedThirdPartyServiceComponentID = watch("selected_third_party_service_component_id");
  const selectedThirdPartyServiceComponent = watch("selected_third_party_service_component");
  const checkId = watch(ServiceField.ID);

  const isChecked = () => {
    let compId = selectedThirdPartyServiceComponentID;
    if (checkId) {
      compId = selectedThirdPartyServiceComponent.id;
    }
    return compId == id;
  };

  return (
    <Button disabled={disabled} onClick={onClick} variant="cloudStatus" className={className}>
      <Checkbox className="gap-3">
        <Checkbox.Input id={name} checked={isChecked()} onChange={() => {}} readOnly={true} disabled={disabled} />
        <CDNImage className="float-start cloud-status-icon" alt={`${group} logo`} src={logo_src} />
        <div className="float-start">
          <div className="row text-start pulseTextBtnSmall">
            <span>{group + " - " + (display_title || title)}</span>
          </div>
          <div className="row text-start pulseTextBodyBold">
            <span>{name}</span>
          </div>
        </div>
      </Checkbox>
    </Button>
  );
};
